<script setup lang="ts">
import { twMerge } from 'tailwind-merge';

// PROPS
interface Props {
    phone: string;
    label?: string;
    class?: string;
    noTracking?: boolean;
}

const { phone, class: className, noTracking = false } = defineProps<Props>();

// EVENTS
const emit = defineEmits<{
    click: [];
}>();

// COMPOSABLES
const { trackPhoneLink } = useTracking();

// DATA
const mergedClass = twMerge('text-primary underline whitespace-nowrap', className);

// METHODS
const onClick = (): void => {
    noTracking || trackPhoneLink(phone);
    emit('click');
};
</script>

<template>
    <a :href="formatPhoneLink(phone)" :class="mergedClass" @click="onClick">
        <slot>{{ label ?? phone }}</slot>
    </a>
</template>
